// StorePage5.tsx
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../components/form/InputField";
import SubmitButton from "../../../components/form/SubmitButton";
import { useTranslation } from "react-i18next";
import MainTitle from "../../../components/ui/MainTitle";
import InputPhoneField from "../../../components/form/InputPhoneField";
import BackButton from "../../../components/ui/BackButton";
import SubTitle from "../../../components/ui/SubTitle";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../../components/form/LoadingButton";

interface Page5FormData {
  phoneLogin: string;
  password: string;
  confirmPassword: string;
}

export default function StorePageFive() {
   const { ownerId} = useParams<{ ownerId: string}>();
   const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { phoneLogin, password ,phone } = useSelector(
    (state: RootState) => state.storeForm
  );

  const storeCreatedData = useSelector((state: RootState) => state.storeForm);
  console.log(storeCreatedData)

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<Page5FormData>({
    defaultValues: { phoneLogin, password, confirmPassword:"" },
  });

  useEffect(() => {
    setValue("phoneLogin", phone);
    setValue("password", password);
  }, [phone, password, setValue]);
  
  const { loading, updateResource } = useUpdateResource();
      
        const handleCreateQuestion = async (data: Page5FormData) => {
          // setLoading(true);
          const formData = new FormData();
            formData.append('subTypeId',`${storeCreatedData.subTypeId}`);
            formData.append('lat',`${storeCreatedData.lat}`);
            formData.append('lng',`${storeCreatedData.lng}`);
            formData.append('phone',`966${storeCreatedData.phone}`);
            formData.append('openingHours',JSON.stringify(storeCreatedData.openingHours));
            if(storeCreatedData.logo){
              formData.append('logo',storeCreatedData.logo);
            }
            if(storeCreatedData.coverImage){
              formData.append('cover',storeCreatedData.coverImage);
            }
             if(storeCreatedData.commercialRegisterFile){
              formData.append('commercialRegisterFile',storeCreatedData.commercialRegisterFile);
            }
            if(storeCreatedData.taxNumberFile){
              formData.append('taxNumberFile',storeCreatedData.taxNumberFile);
            }
            formData.append('password',`${data.password}`);
            formData.append('inStore',`${storeCreatedData.pickupMethods.in_store}`);
            formData.append('driveThru',`${storeCreatedData.pickupMethods.drive_thru}`);
            if(storeCreatedData.commercialRegister){
              formData.append('commercialRegister',`${storeCreatedData.commercialRegister}`);
            }
            if(storeCreatedData.taxNumber){
                formData.append('taxNumber',`${storeCreatedData.taxNumber}`);
            }
            formData.append('city',`${storeCreatedData.city}`);
            formData.append('translations',JSON.stringify(storeCreatedData.name));

            const endPoint = numericOwnerId ? `store/create?ownerId=${numericOwnerId}`:"store/create"
          updateResource(endPoint, formData, numericOwnerId? "admin" : "owner",{
            method: "POST",
            successMessage: t("store_created_success"),
            invalidateQueries:["stores-by-owner"],
            navigateAfter: () => navigate(numericOwnerId?  `/admin/owners/${numericOwnerId}` :"/owner/stores"),
          });
        };            

  return (
    <div className="p-6 container h-[100vh] overflow-auto">
      <form onSubmit={handleSubmit(handleCreateQuestion)} className="flex flex-col gap-4 w-full">
        <MainTitle title={t("create_password")} />

        {/* Phone Login */}
        <div>
          <SubTitle title="phone_login"/>
          <div dir="ltr">
            <InputPhoneField
            rounded={8}
            placeholder={"00 000 000"}
            register={register("phoneLogin")}
            error={errors.phoneLogin}
            readononly={true}
          />
          </div>
        </div>

        <div>
            {/* Password */}
        <InputField
          label={t("store_password")}
          type="password"
          placeholder={t("password")}
          register={register("password", {
            required: t("required_field"),
            minLength: { value: 6, message: t("min_length_6") },
          })}
          error={errors.password}
        />

        {/* Confirm Password */}
        <InputField
          type="password"
          placeholder={t("confirm_password")}
          register={register("confirmPassword", {
            required: t("required_field"),
            validate: (val) => {
              if (watch("password") !== val) {
                return t("passwords_not_match");
              }
            },
          })}
          error={errors.confirmPassword}
        />
        </div>

        <div className="grid grid-cols-2 gap-4">
            <BackButton url={numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page4`:"/owner/add-store/page4"} height={64}/>
            {
              loading
              ?
              <LoadingButton height={64}/>
              :
              <SubmitButton height={64} label={"create"} />
            }
        </div>
      </form>
    </div>
  );
}
